import { render, staticRenderFns } from "./OsapuoltenTiedotKappale.vue?vue&type=template&id=01c9e28d&"
import script from "./OsapuoltenTiedotKappale.vue?vue&type=script&lang=js&"
export * from "./OsapuoltenTiedotKappale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c9e28d')) {
      api.createRecord('01c9e28d', component.options)
    } else {
      api.reload('01c9e28d', component.options)
    }
    module.hot.accept("./OsapuoltenTiedotKappale.vue?vue&type=template&id=01c9e28d&", function () {
      api.rerender('01c9e28d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OsapuoltenTiedotKappale.vue"
export default component.exports